import { render } from "./Profile.vue?vue&type=template&id=543e9c88&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-543e9c88"

export default script